export const validateHbtDataTableCellValue = (value: unknown) => {
  if (typeof value !== 'string') return true;

  const lowerCaseValue = value.trim().toLowerCase();
  return ['', 'unknown', '0', '-'].includes(lowerCaseValue);
};
